// 搜索页面
<template>
    <div>
        搜索
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>